import { Grid, Typography } from '@mui/material';
import { FormikHelpers } from 'formik';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Layout from '../../../core/ui/layout/Layout';
import { useSendApiData } from '../../../core/hooks/useSendApiData';
import { toastError, toastMessage } from '../../../core/utils/ui/alert';
import { parseValidationErrors } from '../../../core/utils/validation';
import useFetchApiData from '../../../core/hooks/useFetchApiData';
import Loader from '../../../core/ui/utility/Loader';
import { VideoEdit, Video } from '../video';
import EditVideoForm from '../components/EditVideoForm';
import ReturnButton from '../../../core/ui/utility/ReturnButton';

const EditVideoContainer = () => {
  const { id } = useParams();
  const { callApi, loading: submitting } = useSendApiData();
  const { fetchData, loading } = useFetchApiData();
  const [video, setVideo] = useState<Video | null>(null);

  const fetchVideo = () =>
    fetchData(`videos/${id}`, {
      onSuccess: (data: Video) => {
        setVideo(data);
      },
    });

  useEffect(() => {
    fetchVideo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (
    values: VideoEdit,
    { setFieldError }: FormikHelpers<VideoEdit>
  ) => {
    // const formData: any = parseFormQuery(values, [])

    await callApi({
      endpoint: `auth-phe24/videos/${id}`,
      method: 'patch',
      data: values,
      headers: {
        'Content-Type': 'application/json',
      },
      onValidationError: (err) => parseValidationErrors(err, setFieldError),
      onError: toastError,
      onSuccess: async (_) => {
        await fetchVideo();
        toastMessage('Video Edited');
      },
    });
  };

  return (
    <Layout renderLeftToolbar={() => <ReturnButton to="/videos" />}>
      <Loader loading={loading || !video}>
        <Grid sx={{ p: 2 }}>
          <Grid container sx={{ mb: 1, px: 1 }}>
            <Typography variant="h5">Edit Video</Typography>
          </Grid>
          <EditVideoForm
            video={video!}
            onSubmit={handleSubmit}
            submitting={submitting}
          />
        </Grid>
      </Loader>
    </Layout>
  );
};

export default EditVideoContainer;
